module.exports = __webpack_public_path__ + "static/media/Icon material-date-range.e679f8a7.svg";